import { tradingSummary } from '@/utils/tradingSummary';

export type MetricTone = 'profit' | 'loss' | 'neutral';

export interface RiskMetric {
  label: string;
  value: string;
  tone: MetricTone;
}

// Every risk figure is read straight off the shared `tradingSummary`, which is
// itself derived from the single trade ledger (`tradeRecords`). There is no
// separate hard-coded source here, so these values can never drift away from
// the counts, rates and extremes shown elsewhere on the site.
export const riskMetrics: RiskMetric[] = [
  { label: 'Best Trade', value: tradingSummary.bestTrade, tone: 'profit' },
  { label: 'Worst Trade', value: tradingSummary.worstTrade, tone: 'loss' },
  {
    label: 'Max Consecutive Wins',
    value: String(tradingSummary.maxConsecutiveWins),
    tone: 'neutral',
  },
  {
    label: 'Max Consecutive Losses',
    value: String(tradingSummary.maxConsecutiveLosses),
    tone: 'neutral',
  },
  {
    label: 'Max Consecutive Profit',
    value: tradingSummary.maxConsecutiveProfit,
    tone: 'profit',
  },
  { label: 'Max Consecutive Loss', value: tradingSummary.maxConsecutiveLoss, tone: 'loss' },
];